import React from 'react';
import get from 'lodash/get';

export default function CsrfInput() {
  const value = get(document.getElementsByName('csrf-token')[0], 'content');
  return <input type="hidden" name="authenticity_token" value={value} />;
}
